<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户钻石</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="选择等级" prop="level">
          <el-select v-model.number="queryParams.level" clearable placeholder="请选择">
            <el-option
              v-for="item in spinLevelData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(2)">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="100px"
        />
        <!--          <el-table-column-->
        <!--            prop="levelId"-->
        <!--            label="等级"-->
        <!--          />-->
        <el-table-column
          prop="spin1"
          label="0-100"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin2"
          label="101-200"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin3"
          label="201-500"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin4"
          label="501-1000"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin5"
          label="1001-2000"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin6"
          label="2001-5000"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin7"
          label="5001-10000"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="spin8"
          label="10001+"
          :formatter="numFormatter"
        />

      </el-table>
    </el-card>

  </div>
</template>

<script>
import { exportStatData, getUserDiamondStat } from '@/api/statistics/user_remain'
import { scientificFormat } from '@/utils'
export default {
  name: 'UserDiamond',
  data() {
    return {
      spinLevelData: [],
      tableData: [],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        level: -1
      }

    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleQuery(select = true) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      if (select) {
        this.getTables()
      }
    },
    getTables() {
      this.spinLevelData = [{ label: '所有等级', value: -1 }]
      getUserDiamondStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list.list
          if (this.tableData) {
            res.data.list.level.forEach(item => {
              this.spinLevelData.push({ label: '等级-' + item, value: item })
            })
          }
          this.queryParams.startDate = res.data.list.req.startDate
          this.queryParams.endDate = res.data.list.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(typ) {
      let start = ''
      let end = ''
      this.handleQuery2(false)
      start = this.queryParams.startDate
      end = this.queryParams.endDate

      if (start === '' || end === '') {
        return
      }
      exportStatData({ startDate: start, endDate: end, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }
  }

}
</script>

<style scoped>

</style>
